export function loginRequest(email, password) {
  return {
    type: '@auth/LOGIN_REQUEST',
    payload: { email, password },
  };
}

export function loginSuccess(token, user) {
  return {
    type: '@auth/LOGIN_SUCCESS',
    payload: { token, user },
  };
}

export function logout() {
  return {
    type: '@auth/LOGOUT_APP',
  };
}

export function loginFail() {
  return {
    type: '@auth/LOGIN_FAIL',
  };
}
